import { TThunkAction } from '../../../../common/types/thunk';
import { buyCustomPackage } from '../../../services/buyCustomPackage';
import { getParameters } from './utils';
import { afterPurchasingPackageThunk } from '../afterPurchasingPackage';
import { pathOr } from 'ramda';
import {
  selectActiveRecommendedPackage,
  selectRecommendedPackageCheckoutModalData,
  selectRecommendedPackagePolygonIds,
  selectRecommendedPackagesAutoprolong,
  selectRecommendedPackageSource,
} from '../../../reducers/v2/recommendedPackages/selectors';

export const buyCustomPackageThunk =
  (): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const state = getState();

    const { services, durationInDays, startDate } = selectRecommendedPackageCheckoutModalData(state);
    const recommendedPackage = selectActiveRecommendedPackage(state);
    const autoProlong = selectRecommendedPackagesAutoprolong(state);
    const polygonIds = selectRecommendedPackagePolygonIds(state);
    const widgetSource = selectRecommendedPackageSource(state);

    const categoriesIds = pathOr([], ['categoriesIds'], recommendedPackage);

    logger.debug('buyCustomPackageThunk state', {
      services: JSON.stringify(services),
      durationInDays,
      startDate,
      recommendedPackage: JSON.stringify(recommendedPackage),
      autoProlong,
      polygonIds,
      widgetSource,
      categoriesIds,
    });

    const parameters = getParameters({
      services,
      durationInDays,
      startDate,
      autoProlong,
      polygonIds,
      categoriesIds,
      widgetSource,
    });

    logger.debug('buyCustomPackageThunk request parameters', {
      parameters: JSON.stringify(parameters),
    });

    const result = await buyCustomPackage({ httpApi, parameters });

    dispatch(afterPurchasingPackageThunk(result));
  };
